import React, { Component } from 'react';
import AppStore from '../../stores/app-store.js'
import { Link } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import { Card, CardTitle, CardText } from 'material-ui/Card';
import '../../grid.css';
import './MostraHistoria.css';

import { deepOrange500 } from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

const muiTheme = getMuiTheme({
    palette: {
        accent1Color: deepOrange500,
    },
});



const stylelink = {
    margin: 12,
    float: 'right',
};

class MostraHistoria extends Component {


    constructor() {
        super();
        this.state = {
            sequenciaNumero: 0,
            sequenciaCartas: [],
            sequenciaHistorias: [],
            legendas: AppStore.legendas,
        }
        this.onChangeLingua = this.onChangeLingua.bind(this);
    }

    componentWillMount() {
        this.setState({
            sequenciaNumero: AppStore.getSequenciaNumero(),
            sequenciaCartas: AppStore.getSequenciaCartas(),
            sequenciaHistorias: AppStore.getSequenciaHistorias(),

        }

        );
        AppStore.addChangeLinguaListener(this.onChangeLingua);
    }

    componentWillUnmount() {
        AppStore.removeChangeLinguaListener(this.onChangeLingua);
    }


    onChangeLingua() {
        this.setState({
            legendas: AppStore.legendas,
        })
    }

    render() {
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div className="MostraHistoria">
                    <Card>
                        <CardTitle title={this.state.legendas.historia} />
                        <CardText>
                            {this.state.sequenciaHistorias.map(function (paragrafo) {
                                return <p>{paragrafo + '.'}</p>
                            })}
                        </CardText>
                    </Card>
                    <h2>{this.state.legendas.desejaDoar}</h2>
                    <div className="ui-g">
                        <div className="ui-g-4">
                            <RaisedButton containerElement={<Link to="/guardaeautoriza" />}
                                linkButton={true}
                                label={this.state.legendas.sim}
                                style={stylelink}
                                primary={true}
                            />
                        </div>
                        <div className="ui-g-4">
                            <RaisedButton containerElement={<Link to="/guardahistoria" />}
                                linkButton={true}
                                label={this.state.legendas.nao}
                                style={stylelink}
                                primary={true}
                            />
                        </div>
                    </div>
                </div>
            </MuiThemeProvider>
        )
    }
}

export default MostraHistoria;


// WEBPACK FOOTER //
// ./src/componentes/mostrahistoria/MostraHistoria.js